import { __decorate } from "tslib";
import { AsnProp, AsnType, AsnTypeTypes, OctetString } from "@peculiar/asn1-schema";
import { Name } from "@peculiar/asn1-x509";
export class KeyHash extends OctetString {
}
let ResponderID = class ResponderID {
    constructor(params = {}) {
        Object.assign(this, params);
    }
};
__decorate([
    AsnProp({ type: Name, context: 1 })
], ResponderID.prototype, "byName", void 0);
__decorate([
    AsnProp({ type: KeyHash, context: 2 })
], ResponderID.prototype, "byKey", void 0);
ResponderID = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], ResponderID);
export { ResponderID };
